import { UpsertKeywordsModalContainer, VerifyModalContainer } from "src/app/containers";
import { useIntl } from "react-intl";
import { SimpleEntityGrid } from "src/app/components/grid/SimpleEntityGrid";
import { KeywordsDTOSchema } from "src/app/types/keywords";
import { KeywordsTransport } from "src/app/transports/keywords";
import { useState } from "react";
import useKeywordsRanklvl3GridColumns from "./useKeywordsRanklvl3GridColumns";
import useKeywordsRanklvl3GridDefaultFilters from "./useKeywordsRanklvl3GridDefaultFilters";
import { getRowStyle } from "src/app/utils/aggrid/keywordRowColor";
import { KeywordMetricsModalContainer } from "src/app/components";

const ToVerifyKeywordsRanklvl3Grid = () => {
    const { formatMessage } = useIntl();

    const [showModal, setShowModal] = useState(false);

    const gridColumns = useKeywordsRanklvl3GridColumns();
    const defaultFilters = useKeywordsRanklvl3GridDefaultFilters();

    return (
        <>
            <SimpleEntityGrid
                columns={gridColumns}
                defaultFilters={defaultFilters}
                actions={["disable", "verified"]}
                rowModelType="serverSide"
                getRowStyle={getRowStyle}
                toolbarButtonAction={{
                    add: false,
                    export: true,
                    active: true,
                    metrics: true,
                    custom: [
                        {
                            title: "Import",
                            action: () => {
                                setShowModal(true);
                            },
                            selectedRows: false,
                        },
                    ],
                }}
                verifyFormBodyContainer={VerifyModalContainer}
                entityName={formatMessage({ id: "common.entity.keyword" })}
                metricsFormBodyContainer={KeywordMetricsModalContainer}
                listHandler={(filters) =>
                    KeywordsTransport.list("ranklvl3", {
                        ...filters,
                        filterModel: {
                            verified: {
                                type: "equals",
                                filter: false,
                            },
                            ...filters?.filterModel,
                        },
                    })
                }
                totalFilteredHandle={(filters) =>
                    KeywordsTransport.totalFiltered("ranklvl3", {
                        ...filters,
                        filterModel: {
                            verified: {
                                type: "equals",
                                filter: false,
                            },
                            ...filters?.filterModel,
                        },
                    })
                }
                totalRowsHandle={() => KeywordsTransport.total("ranklvl3")}
                formTransformer={KeywordsTransport.formTransformer}
                toggleActiveHandler={KeywordsTransport.toggleActive}
                saveHandler={KeywordsTransport.save}
                formBody={() => <></>}
                validationSchema={KeywordsDTOSchema}
            />
            <UpsertKeywordsModalContainer
                showModal={showModal}
                handleClose={() => setShowModal(false)}
            />
        </>
    );
};

export default ToVerifyKeywordsRanklvl3Grid;
